module.exports = __webpack_public_path__ + "img/5-s.9ae0013c.png";